module.exports = __webpack_public_path__ + "img/mail.bc88c7fe.svg";